<template>
  <n-dialog-provider>
    <div class="color-scheme--scheme-2">
      <div id="app-container">
        <RouterView :key="$route.query.placeId" />
      </div>
    </div>
  </n-dialog-provider>
</template>

<script setup>
import { onBeforeMount } from "vue";
import { NDialogProvider } from "naive-ui";
import { RouterView } from "vue-router";

// stores
import { useTranslationsStore } from "./stores/translations";

const translationsStore = useTranslationsStore();

onBeforeMount(async () => {
  await translationsStore.fetchTranslations();
});
</script>
